import type { RootState } from 'models';

export const selectVerification = ({ verification }: RootState) => verification;
export const selectVerificationLoading = ({ verification }: RootState) => verification.loading;
export const selectVerificationCleanedUp = ({ verification }: RootState) => verification.isCleaningUp;
